import { HttpErrorResponse } from '@angular/common/http';
import {
    GetTranslationsDto,
    IAccountingBasisDTO,
    IAccountingBasisExtendedDTO,
    ICurrencyExtendedDTO,
    IFinancialLineItemDTO,
    IFinancialLineItemExtendedDTO,
    IFinancialLineItemUpdateRequest,
    ILegalFormDTO,
    ILegalFormExtendedDTO,
    UpdateTranslationsDto,
} from '@modeso/types__aumico-lib-settings-be';
import { createAction, props } from '@ngrx/store';
import { IEditData } from '../interfaces/edit-data.interface';
import { IFilterOptions } from '../interfaces/filter-options.interface';
import { SettingsTranslationResponse } from '../interfaces/settings-response.interface';
import { SettingsTranslationRequest } from '../interfaces/settings-translation-request.interface';

export const accountingBasisActions = {
    getAllAccountingBasis: createAction(
        '[Aumico-Settings] accountingBasisActions.getAllAccountingBasis',
        props<{ payload: IFilterOptions | undefined }>(),
    ),
    onGetAllAccountingBasisSuccess: createAction(
        '[Aumico-Settings] accountingBasisActions.onGetAllAccountingBasisSuccess',
        props<{ payload: IAccountingBasisExtendedDTO[] }>(),
    ),
    onGetAllAccountingBasisFailed: createAction(
        '[Aumico-Settings] accountingBasisActions.onDGetAllAccountingBasisFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),

    setActiveAccountingBasis: createAction(
        '[Aumico-Settings] accountingBasisActions.setActiveAccountingBasis',
        props<{ payload?: IAccountingBasisExtendedDTO | string }>(),
    ),
    submitCreateAccountingBasis: createAction(
        '[Aumico-Settings] accountingBasisActions.submitCreateAccountingBasis',
        props<{ payload: IAccountingBasisDTO }>(),
    ),
    onSubmitCreateAccountingBasisSuccess: createAction(
        '[Aumico-Settings] accountingBasisActions.onSubmitCreateAccountingBasisSuccess',
    ),
    onSubmitCreateAccountingBasisFailed: createAction(
        '[Aumico-Settings] accountingBasisActions.onSubmitCreateAccountingBasisFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),
    submitEditAccountingBasis: createAction(
        '[Aumico-Settings] accountingBasisActions.submitEditAccountingBasis',
        props<IEditData<Pick<IAccountingBasisDTO, 'text' | 'countryISO31661Alpha2Codes'>>>(),
    ),
    onSubmitEditAccountingBasisSuccess: createAction(
        '[Aumico-Settings] accountingBasisActions.onSubmitEditAccountingBasisSuccess',
    ),
    onSubmitEditAccountingBasisFailed: createAction(
        '[Aumico-Settings] accountingBasisActions.onSubmitEditAccountingBasisFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),
};

export const legalFormActions = {
    getAllLegalForm: createAction(
        '[Aumico-Settings] legalFormActions.getAllLegalForm',
        props<{ payload: IFilterOptions | undefined }>(),
    ),
    onGetAllLegalFormSuccess: createAction(
        '[Aumico-Settings] legalFormActions.onGetAllLegalFormSuccess',
        props<{ payload: ILegalFormExtendedDTO[] }>(),
    ),
    onGetAllLegalFormFailed: createAction(
        '[Aumico-Settings] legalFormActions.onDGetAllLegalFormFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),

    setActiveLegalForm: createAction(
        '[Aumico-Settings] legalFormActions.setActiveLegalForm',
        props<{ payload?: ILegalFormExtendedDTO | string }>(),
    ),
    submitCreateLegalForm: createAction(
        '[Aumico-Settings] legalFormActions.submitCreateLegalForm',
        props<{ payload: ILegalFormDTO }>(),
    ),
    onSubmitCreateLegalFormSuccess: createAction('[Aumico-Settings] legalFormActions.onSubmitCreateLegalFormSuccess'),
    onSubmitCreateLegalFormFailed: createAction(
        '[Aumico-Settings] legalFormActions.onSubmitCreateLegalFormFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),
    submitEditLegalForm: createAction(
        '[Aumico-Settings] legalFormActions.submitEditLegalForm',
        props<IEditData<Pick<ILegalFormDTO, 'text' | 'countryISO31661Alpha2Codes'>>>(),
    ),
    onSubmitEditLegalFormSuccess: createAction('[Aumico-Settings] legalFormActions.onSubmitEditLegalFormSuccess'),
    onSubmitEditLegalFormFailed: createAction(
        '[Aumico-Settings] legalFormActions.onSubmitEditLegalFormFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),
};

export const financialLineItemActions = {
    getAllFinancialLineItem: createAction('[Aumico-Settings] financialLineItemActions.getAllFinancialLineItem'),
    onGetAllFinancialLineItemSuccess: createAction(
        '[Aumico-Settings] financialLineItemActions.onGetAllFinancialLineItemSuccess',
        props<{ payload: IFinancialLineItemExtendedDTO[] }>(),
    ),
    onGetAllFinancialLineItemFailed: createAction(
        '[Aumico-Settings] financialLineItemActions.onDGetAllFinancialLineItemFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),

    setActiveFinancialLineItem: createAction(
        '[Aumico-Settings] financialLineItemActions.setActiveFinancialLineItem',
        props<{
            payload?: IFinancialLineItemExtendedDTO | string;
        }>(),
    ),
    submitCreateFinancialLineItem: createAction(
        '[Aumico-Settings] financialLineItemActions.submitCreateFinancialLineItem',
        props<{
            payload: IFinancialLineItemDTO;
        }>(),
    ),
    onSubmitCreateFinancialLineItemSuccess: createAction(
        '[Aumico-Settings] financialLineItemActions.onSubmitCreateFinancialLineItemSuccess',
    ),
    onSubmitCreateFinancialLineItemFailed: createAction(
        '[Aumico-Settings] financialLineItemActions.onSubmitCreateFinancialLineItemFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),
    submitEditFinancialLineItem: createAction(
        '[Aumico-Settings] financialLineItemActions.submitEditFinancialLineItem',
        props<IEditData<IFinancialLineItemUpdateRequest>>(),
    ),
    onSubmitEditFinancialLineItemSuccess: createAction(
        '[Aumico-Settings] financialLineItemActions.onSubmitEditFinancialLineItemSuccess',
    ),
    onSubmitEditFinancialLineItemFailed: createAction(
        '[Aumico-Settings] financialLineItemActions.onSubmitEditFinancialLineItemFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),
};

export const currencyActions = {
    getAllCurrency: createAction('[Aumico-Settings] currencyActions.getAllCurrency'),
    onGetAllCurrencySuccess: createAction(
        '[Aumico-Settings] currencyActions.onGetAllCurrencySuccess',
        props<{ payload: ICurrencyExtendedDTO[] }>(),
    ),
    onGetAllCurrencyFailed: createAction(
        '[Aumico-Settings] currencyActions.onGetAllCurrencyFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),
};

export const translationsActions = {
    getTranslations: createAction(
        '[Aumico-Settings] translationsActions.getAllCurrency',
        props<{ locales: string[]; untranslatedOnly: boolean }>(),
    ),
    onGetTranslationsSuccess: createAction(
        '[Aumico-Settings] translationsActions.onGetTranslationsSuccess',
        props<{ payload: GetTranslationsDto }>(),
    ),
    onGetTranslationsFailed: createAction(
        '[Aumico-Settings] translationsActions.onGetTranslationsFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),
    updateTranslations: createAction(
        '[Aumico-Settings] translationsActions.updateTranslations',
        props<{ payload: UpdateTranslationsDto }>(),
    ),
    onUpdateTranslationsSuccess: createAction('[Aumico-Settings] translationsActions.onUpdateTranslationsSuccess'),
    onUpdateTranslationsFailed: createAction(
        '[Aumico-Settings] translationsActions.onUpdateTranslationsFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),
    getSettingsTargetTranslations: createAction(
        '[Aumico-Settings] translationsActions.getSettingsTargetTranslations',
        props<{ payload: SettingsTranslationRequest }>(),
    ),
    onGetSettingsTargetTranslationsSuccess: createAction(
        '[Aumico-Settings] translationsActions.onGetSettingsTargetTranslationsSuccess',
        props<{ payload: SettingsTranslationResponse }>(),
    ),
    onGetSettingsTargetTranslationsFailed: createAction(
        '[Aumico-Settings] translationsActions.onGetSettingsTargetTranslationsFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),
};
